import { useEffect } from "react";

import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useTranslation } from "react-i18next";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import CompanyInfo from "components/CompanyInfo/CompanyInfo";

const useStyles = makeStyles((theme) => ({
  content: {
    padding: theme.spacing(3),
  },
}));

const CompanyDetail = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { myCompany } = props;

  useEffect(() => {}, []);

  return (
    <Paper className={classes.content}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h4">{t("Yrityksen perustiedot")}</Typography>
      </Box>
      <CompanyInfo company={myCompany} />
    </Paper>
  );
};

export default CompanyDetail;
